import { ua } from '@/utils/util'

function setupWebViewJavascriptBridge(callback: Function) {
  if (window.WebViewJavascriptBridge) {
    return callback(window.WebViewJavascriptBridge)
  }

  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback)
  }

  window.WVJBCallbacks = [callback]
  const WVJBIframe = document.createElement('iframe')
  WVJBIframe.style.display = 'none'
  WVJBIframe.src = 'https://__bridge_loaded__'
  document.documentElement.appendChild(WVJBIframe)

  setTimeout(function () {
    document.documentElement.removeChild(WVJBIframe)
  }, 0)
}

export function callNative(name: string, params?: any) {
  params = typeof params === 'object' ? JSON.stringify(params) : params
  if (ua.isAndroid()) {
    return new Promise((resolve) => {
      if (!window.aomiPaySdk[name]) {
        console.log(`aomiPaySdk缺少${name}方法！`)
      }

      if (params) {
        resolve(window.aomiPaySdk[name](params))
      } else {
        resolve(window.aomiPaySdk[name]())
      }
    })
  } else if (ua.isiOS()) {
    return new Promise((resolve) => {
      setupWebViewJavascriptBridge((bridge) => {
        bridge.callHandler(name, params, function responseCallback(responseData: any) {
          resolve(responseData)
        })
      })
    })
  }
}
